import React from 'react';
import { LatestDetection } from '../SessionDetectionContextProvider/useSessionDetectionContext';

type RState<S> = [S, React.Dispatch<React.SetStateAction<S>>]

export interface SessionStoreContextProps {
  topicMentions: RState<{ clientMentions: string[], agentMentions: string[] }>;
  latestDetection: RState<LatestDetection | null>;
  detectionHistory: RState<(LatestDetection & { cardTitle?: string, commandTitle?: string })[]>;
  context: RState<string | null>;
  sessionId: RState<string | null>;
  terminating: RState<string | null>;
  conversationEngaged: RState<boolean>;
  sessionLoading: RState<boolean>;
  focusMode: RState<boolean>;
}

export const SessionStoreContext = React.createContext<SessionStoreContextProps | null>(null);

export default function useSessionStoreContext() {
  const context = React.useContext(SessionStoreContext);
  if (!context) {
    throw new Error('useSessionStoreContext must be used within a SessionStateStoreContextProvider');
  }
  return context;
}
